function _templateObject() {
  var data = _taggedTemplateLiteral(["\n          height: ", "px;\n      "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled, { css } from 'styled-components';
import { addStyleIfPropTruly } from "../../utils/styledComponents";
import { addFocusedStyle, addErrorStyle, addErrorFocusedStyle, addDisabledStyle, addHoverStyle } from "./helpers";
import { addColors, getStyleValueByTypeof } from "../../helpers/helpers";
import { getTypographyFontSize } from "../../theme/selectors";
import { mediaSmDown } from "../../theme/helpers/media";
import { EnumInputTypes } from "./index";
import ComponentAddon from "../ComponentAddon/ComponentAddon";
export var InputContainer = styled.div.withConfig({
  displayName: "styled__InputContainer",
  componentId: "du11cg-0"
})(["display:block;width:100%;position:relative;"]);
export var Placeholder = styled.div.withConfig({
  displayName: "styled__Placeholder",
  componentId: "du11cg-1"
})(["position:absolute;pointer-events:none;", ";"], function (_ref) {
  var placeholder = _ref.theme.input.placeholder;
  return css(["color:", ";", ""], placeholder.color, addStyleIfPropTruly('required', "\n      &:after {\n        content: '*';\n        padding-left: 5px;\n        color: ".concat(placeholder.asteriskColor, ";\n        font-style: inherit;\n      }\n  ")));
});
export var ErrorContainer = styled.div.withConfig({
  displayName: "styled__ErrorContainer",
  componentId: "du11cg-2"
})(["position:relative;"]);
export var InputWrapper = styled.div.withConfig({
  displayName: "styled__InputWrapper",
  componentId: "du11cg-3"
})(["width:100%;box-sizing:border-box;color:inherit;display:flex;align-items:center;", " ", " ", " ", " ", " ", ""], function (_ref2) {
  var size = _ref2.size,
      _ref2$theme$input = _ref2.theme.input,
      bgColor = _ref2$theme$input.bgColor,
      borderColor = _ref2$theme$input.borderColor,
      fontSize = _ref2$theme$input.fontSize,
      height = _ref2$theme$input.height,
      borderRadius = _ref2$theme$input.borderRadius,
      padding = _ref2$theme$input.padding,
      transition = _ref2$theme$input.transition,
      fontWeight = _ref2$theme$input.fontWeight;
  return css(["", " ", " height:", "px;border-radius:", "px;", " ", " ", " ", ""], getTypographyFontSize(fontSize[size]), addColors({
    bgColor: bgColor,
    borderColor: borderColor
  }), height["default"][size], borderRadius[size], padding[size] && "padding: ".concat(typeof padding[size] === 'number' ? "0 ".concat(padding[size], "px") : padding[size], ";"), transition && "transition: ".concat(transition, ";"), fontWeight && "font-weight: ".concat(fontWeight, ";"), height.mobile && mediaSmDown(_templateObject(), height.mobile[size]));
}, addDisabledStyle(css(["", ""], function (_ref3) {
  var disabled = _ref3.theme.input.disabled;
  return css(["", " ", " ", "{", "}"], addColors(disabled), disabled.opacity && "opacity: ".concat(disabled.opacity, ";"), Placeholder, disabled.placeholderColor && "color: ".concat(disabled.placeholderColor, ";"));
})), addErrorStyle(css(["", ""], function (_ref4) {
  var error = _ref4.theme.input.error;
  return addColors(error);
})), addHoverStyle(css(["&:hover{", ""], function (_ref5) {
  var input = _ref5.theme.input;
  return input.hover && css(["", " ", "{", "}"], addColors(input.hover), Placeholder, input.hover.placeholderColor && "color: ".concat(input.hover.placeholderColor, ";"));
})), addFocusedStyle(css(["", ""], function (_ref6) {
  var focus = _ref6.theme.input.focus;
  return css(["", " ", "{", "}"], addColors(focus), Placeholder, focus.placeholderColor && "color: ".concat(focus.placeholderColor, ";"));
})), addErrorFocusedStyle(css(["", ""], function (_ref7) {
  var input = _ref7.theme.input;
  return input.focusError && css(["", " ", "{", "}"], addColors(input.focusError), Placeholder, input.focusError.placeholderColor && "color: ".concat(input.focusError.placeholderColor, ";"));
})));
export var InputContent = styled.div.withConfig({
  displayName: "styled__InputContent",
  componentId: "du11cg-4"
})(["flex-grow:1;display:flex;height:100%;align-items:center;position:relative;"]);
export var InputStyled = styled.input.withConfig({
  displayName: "styled__InputStyled",
  componentId: "du11cg-5"
})(["outline:none;border:none;margin:0;padding:0;background-color:transparent;flex-grow:1;line-height:1.5;box-sizing:border-box;font:inherit;max-width:100%;width:100%;color:inherit;&:disabled{@media not all and (min-resolution:0.001dpcm){filter:brightness(0.8);}}&::-ms-clear,&::-ms-reveal{display:none;}", ""], addStyleIfPropTruly('readOnly', 'cursor: pointer;'));
var AdditionalText = styled.div.withConfig({
  displayName: "styled__AdditionalText",
  componentId: "du11cg-6"
})(["box-sizing:border-box;line-height:1;", ";"], function (_ref8) {
  var position = _ref8.position,
      _ref8$indent = _ref8.indent,
      indent = _ref8$indent === void 0 ? 6 : _ref8$indent;
  return position === 'top' ? "padding-bottom: ".concat(indent, "px") : "padding-top: ".concat(indent, "px;");
});
export var InputLabel = styled(AdditionalText).attrs(function (_ref9) {
  var _input$label;

  var input = _ref9.theme.input;
  return {
    position: 'top',
    indent: (_input$label = input.label) === null || _input$label === void 0 ? void 0 : _input$label.indent
  };
}).withConfig({
  displayName: "styled__InputLabel",
  componentId: "du11cg-7"
})(["", ";"], function (_ref10) {
  var _label$fontSize;

  var size = _ref10.size,
      _ref10$theme$input = _ref10.theme.input,
      label = _ref10$theme$input.label,
      padding = _ref10$theme$input.padding;
  return css(["color:", ";", " ", ""], (label === null || label === void 0 ? void 0 : label.color) || 'inherit', getTypographyFontSize(label === null || label === void 0 ? void 0 : (_label$fontSize = label.fontSize) === null || _label$fontSize === void 0 ? void 0 : _label$fontSize[size]), (label === null || label === void 0 ? void 0 : label.withPadding) && "padding-left: ".concat(padding[size], "px;"));
});
export var HelperText = styled(AdditionalText).attrs(function (_ref11) {
  var _input$helperText;

  var input = _ref11.theme.input;
  return {
    position: 'bottom',
    indent: (_input$helperText = input.helperText) === null || _input$helperText === void 0 ? void 0 : _input$helperText.indent
  };
}).withConfig({
  displayName: "styled__HelperText",
  componentId: "du11cg-8"
})(["", ";"], function (_ref12) {
  var _helperText$fontSize;

  var size = _ref12.size,
      _ref12$theme$input = _ref12.theme.input,
      helperText = _ref12$theme$input.helperText,
      padding = _ref12$theme$input.padding;
  return css(["color:", ";", " ", ""], (helperText === null || helperText === void 0 ? void 0 : helperText.color) || 'inherit', getTypographyFontSize(helperText === null || helperText === void 0 ? void 0 : (_helperText$fontSize = helperText.fontSize) === null || _helperText$fontSize === void 0 ? void 0 : _helperText$fontSize[size]), (helperText === null || helperText === void 0 ? void 0 : helperText.withPadding) && "padding-left: ".concat(padding[size], "px;"));
});
export var Error = styled(AdditionalText).attrs(function (_ref13) {
  var _input$errorText;

  var input = _ref13.theme.input;
  return {
    position: 'bottom',
    indent: (_input$errorText = input.errorText) === null || _input$errorText === void 0 ? void 0 : _input$errorText.indent
  };
}).withConfig({
  displayName: "styled__Error",
  componentId: "du11cg-9"
})(["", ";"], function (_ref14) {
  var _errorText$fontSize;

  var size = _ref14.size,
      errorType = _ref14.errorType,
      _ref14$theme$input = _ref14.theme.input,
      errorText = _ref14$theme$input.errorText,
      padding = _ref14$theme$input.padding;
  return css(["color:", ";", " ", " ", " ", ""], (errorText === null || errorText === void 0 ? void 0 : errorText.color) || 'inherit', getTypographyFontSize(errorText === null || errorText === void 0 ? void 0 : (_errorText$fontSize = errorText.fontSize) === null || _errorText$fontSize === void 0 ? void 0 : _errorText$fontSize[size]), (errorText === null || errorText === void 0 ? void 0 : errorText.withPadding) && "padding-left: ".concat(padding[size], "px;"), (errorText === null || errorText === void 0 ? void 0 : errorText.absolute) && 'position: absolute;', errorType === EnumInputTypes.tooltip && "\n        position: absolute;\n        top: -8px;\n        right:0;\n        z-index: 2;\n        padding: 1px 12px 2px;\n        min-height: 24px;\n        border-radius: 24px;\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        transform: translateY(-100%);\n        ".concat((errorText === null || errorText === void 0 ? void 0 : errorText.bgColor) && "\n          background-color: ".concat(errorText.bgColor, ";\n          &:after {\n            content: '';\n            display: block;\n            width: 12px;\n            height: 6px;\n            box-sizing: border-box;\n            position: absolute;\n            bottom: 1px;\n            transform: translate(-50%, 100%);\n            left: 50%;\n            border-top: 6px solid ").concat(errorText.bgColor, ";\n            border-right: 6px solid transparent;\n            border-left: 6px solid transparent;\n          }\n        "), "\n      "));
});
export var InputAddon = styled(ComponentAddon).attrs({
  marginSize: 2
}).withConfig({
  displayName: "styled__InputAddon",
  componentId: "du11cg-10"
})(["", ""], function (_ref15) {
  var _ref15$theme$input = _ref15.theme.input,
      addonWidth = _ref15$theme$input.addonWidth,
      addonHeight = _ref15$theme$input.addonHeight;
  return "\n    width: ".concat(getStyleValueByTypeof(addonWidth) || '24px', ";\n    height: ").concat(getStyleValueByTypeof(addonHeight) || '24px', ";\n  ");
});